import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from 'antd';
import { AccountModalSelector, Form } from '~/components';
import { usePath } from '~/hooks';
import { useEmployeesRoles } from '~/hooks/employees';
import { inputWidth } from '~/utils/filters';

const { Option } = Select;

const Filters: FC<any> = () => {
  const [form] = Form.useForm();
  const { t } = useTranslation('employees');
  const { changePath, params } = usePath();

  const handleChange = (_changed: any, values: Record<string, any>) => {
    changePath({ filter: values });
  };

  const { data: employeeRoles, isLoading } = useEmployeesRoles();

  return (
    <Form form={form} layout="inline" onValuesChange={handleChange} initialValues={params.filter}>
      <Form.Item name="role">
        <Select placeholder={t('role')} allowClear style={inputWidth} loading={isLoading}>
          {employeeRoles?.map(({ role, name }) => (
            <Option key={role} value={role}>
              {name}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <AccountModalSelector
        selectorForm={form}
        name="accountId"
        selectMode="single"
        label={undefined}
        placeholder={t('account')}
        style={inputWidth}
        onChange={() => {
          changePath({
            filter: {
              ...form.getFieldsValue(),
              accountId: form.getFieldValue('accountId'),
            },
          });
        }}
      />
    </Form>
  );
};

export default Filters;
